/**
 * 直送退货管理
 */

import request from '@/utils/request'

/**
 * 登录
 * @param data
 */
export function userLogin(data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

/**
 * 获取动态验证码
 * @param data
 */
export function userGetCode(data) {
  return request({
    url: '/getCode',
    method: 'post',
    data
  })
}

/**
 * 登出
 * @param data
 */
export function loginOut(data) {
  return request({
    url: '/logout',
    method: 'post',
    data
  })
}

/**
 * 是否有未读消息
 * @param data
 */
export function sysNoticeSelectNoReadNotice(data) {
  return request({
    url: '/sysNotice/selectNoReadNotice',
    method: 'post',
    data
  })
}

